// import {
//   CriteriaWithPagination,
//   EuiBasicTable,
//   EuiBasicTableColumn,
//   EuiButton,
//   EuiEmptyPrompt,
//   EuiFormRow,
//   EuiImage,
//   EuiLink,
//   EuiSpacer,
//   Pagination,
// } from "@elastic/eui";
// import { Box, Button, Menu, Select, Text } from "@mantine/core";
// import { modals } from "@mantine/modals";
// import React, { ReactNode, useEffect, useState } from "react";
// import {
//   isNullOrEmpty,
//   isNullOrUndefined,
//   isNullOrUndefinedArry,
// } from "../../../../_base/extension/StringExtension";
// import Repository from "../../../../_base/helper/HttpHelper";
// import { paginationBase } from "../../../../_base/model/_base/BaseTable";
// import { ParamSearchBase } from "../../../../_base/model/_base/ParamSearchBase";
// import { getDataListProduct } from "../../../../api/ApiProduct";
// import { getDataBrand } from "../../../../api/ApiSell";
// import AppSearch from "../../../../common/AppSearch";
// import { Brand, TblItemCommand } from "../../../../model/ProductList";

// const noItemsFoundMsg = "Không có kết quả tìm kiếm phù hợp...";

// const dataItemArrangements = [
//   "Thứ tự cửa hàng",
//   "Xem nhiều nhất",
//   "Mới nhất",
//   "Chưa cập nhật lâu nhất",
// ];

// const dataItemFiltering = [
//   "Còn hàng",
//   "Có khuyến mãi",
//   "Đang hiển thị",
//   "SP mới",
//   "SP HOT",
//   "SP xả hàng",
//   "SP bán chạy",
// ];

// const FormChooseItem = ({ onChooseItem }: FormChooseItemProps) => {
//   const [toltal, setTotal] = useState(0);
//   const [dataBrand, setDataBrand] = useState<Brand[]>();

//   const columns: Array<EuiBasicTableColumn<TblItemCommand>> = [
//     {
//       field: "id",
//       name: "Id",
//       sortable: true,
//       truncateText: true,
//       width: "5%",
//     },
//     {
//       field: "itemName",
//       name: "Tên sản phẩm",
//       footer: <em>Page totals: {toltal}</em>,
//       sortable: true,
//       truncateText: true,
//       width: "20%",

//       render: (itemName: string) => (
//         <EuiLink target="_blank">{itemName}</EuiLink>
//       ),
//     },
//     {
//       field: "itemCode",
//       name: "Mã sản phẩm",
//       footer: <em>Page totals: {toltal}</em>,
//       sortable: true,
//       truncateText: true,
//       width: "7%",
//     },
//     {
//       field: "primaryImage",
//       name: "Ảnh",
//       sortable: true,
//       truncateText: true,
//       width: "7%",
//       render: (urlCanonical: any) => {
//         return (
//           <EuiImage
//             size=""
//             width={60}
//             height={80}
//             src={urlCanonical}
//             alt="alt"
//           />
//         );
//       },
//     },
//     {
//       field: "brandId",
//       name: "Thương hiệu",
//       sortable: true,
//       truncateText: true,
//       width: "8%",
//       render: (brandId: number) => {
//         return (
//           <EuiLink target="_blank">
//             {dataBrand?.filter((item: any) => item?.id === brandId)[0]?.name}
//           </EuiLink>
//         );
//       },
//     },
//     {
//       field: "unitSellingPrice",
//       name: "Giá bán",
//       sortable: true,
//       truncateText: true,
//       render: (price: number) => {
//         return (
//           <>
//             <Text fw={600} style={{ color: "red", marginRight: 4 }}>
//               {convertToVnd(price)}
//             </Text>
//             <Text>vnd</Text>
//           </>
//         );
//       },
//     },
//     {
//       field: "discountValue",
//       name: "Giảm giá",
//       sortable: true,
//       truncateText: true,
//       render: (discountValue: number) => {
//         return (
//           <Box display={"flex"} style={{ flexDirection: "column" }}>
//             <Box display={"flex"}>
//               <Text>Giảm giá</Text>
//               <Text fw={600} style={{ color: "red", marginLeft: 4 }}>
//                 {discountValue ? `${discountValue}%` : "0%"}
//               </Text>
//             </Box>
//             <Text>so với giá gốc</Text>
//           </Box>
//         );
//       },
//     },
//     {
//       field: "onhandQuantyty",
//       name: "Số lượng tồn kho",
//       sortable: true,
//       truncateText: true,
//       render: (onhandQuantyty: number) => {
//         return (
//           <Box display={"flex"} style={{ flexDirection: "column" }}>
//             <Box display={"flex"}>
//               <Text>Số lượng tổng:</Text>
//               <Text fw={600} style={{ color: "red", marginLeft: 4 }}>
//                 {onhandQuantyty}
//               </Text>
//             </Box>
//             <EuiLink>
//               {onhandQuantyty == 0 ? (
//                 <Text style={{ color: "red" }}>hết hàng</Text>
//               ) : (
//                 <Text style={{ color: "blue" }}>còn hàng</Text>
//               )}
//             </EuiLink>
//           </Box>
//         );
//       },
//     },
//     {
//       field: "warrantyDescrition",
//       name: "Thông tin bảo hành",
//       sortable: true,
//       truncateText: true,
//       render: (warrantyDescrition: number) => {
//         return (
//           <Box display={"flex"} style={{ flexDirection: "column" }}>
//             <Box display={"flex"}>
//               <Text>Thời hạn:</Text>
//               <EuiLink style={{ marginLeft: 4 }}>{warrantyDescrition}</EuiLink>
//             </Box>
//           </Box>
//         );
//       },
//     },
//     {
//       field: "color",
//       name: "Màu sắc",
//       sortable: true,
//       truncateText: true,
//       width: "5%",
//       render: (color: string) => (
//         <>
//           <div style={{ display: "flex", alignItems: "center" }}>
//             <div
//               style={{
//                 width: "15px",
//                 height: "15px",
//                 borderRadius: "50%",
//                 backgroundColor: color,
//                 marginRight: "8px",
//               }}
//             ></div>
//             {color}
//           </div>
//         </>
//       ),
//     },
//     {
//       name: "Chọn",
//       width: "8%",
//       render: (item: TblItemCommand) => {
//         return (
//           <Button onClick={() => handleChooseItem(item)}>Chọn sản phẩm</Button>
//         );
//       },
//     },
//   ];

//   const [loading, setLoading] = useState(false);
//   const [users, setUsers] = useState<TblItemCommand[]>([]);
//   const [message, setMessage] = useState<ReactNode>(
//     <EuiEmptyPrompt
//       title={<h3>Dữ liệu rỗng !</h3>}
//       titleSize="xs"
//       body="Tải lại dữ liệu nếu trường hợp bạn không thấy có dữ liệu hiển thị !"
//       actions={
//         <EuiButton
//           size="s"
//           key="loadUsers"
//           onClick={async () => {
//             await fetchDataItem(pagination.pageIndex, pagination.pageSize);
//           }}
//         >
//           Tải dữ liệu !
//         </EuiButton>
//       }
//     />
//   );
//   const [error, setError] = useState<string | undefined>();
//   const [pagination, setPagination] = useState<Pagination>(paginationBase);
//   const [selectedOptions, setSelected] = useState();
//   const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
//   const [selectedItemFiltering, setSelectedItemFiltering] = useState<
//     string | null
//   >();
//   const [selectedItemArrangements, setSelectedItemArrangements] = useState<
//     string | null
//   >();

//   const elementSearch = [
//     <Menu.Item closeMenuOnClick={false}>
//       <EuiFormRow label="Lọc sản phẩm:">
//         <Select data={dataItemFiltering} onChange={setSelectedItemFiltering} />
//       </EuiFormRow>
//     </Menu.Item>,
//     <Menu.Item closeMenuOnClick={false}>
//       <EuiFormRow label="Sắp xếp sản phẩm:">
//         <Select
//           data={dataItemArrangements}
//           onChange={setSelectedItemArrangements}
//         />
//       </EuiFormRow>
//     </Menu.Item>,
//   ];

//   const fetchDataItem = async (
//     index: number,
//     size?: number,
//     keyWord?: string,
//     inActive?: boolean
//   ) => {
//     setMessage("Đang lấy dữ liệu...");
//     setLoading(true);
//     setUsers([]);
//     setError(undefined);
//     const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
//     try {
//       let urlSearch = `?Skip=${index * (size ?? 0)}&Take=${size}`;
//       if (!isNullOrEmpty(keyWord))
//         urlSearch = urlSearch + `&KeySearch=` + keyWord;
//       if (!isNullOrUndefined(inActive))
//         urlSearch = urlSearch + `&Active=` + inActive;
//       let callapi = await getDataListProduct(urlSearch);
//       if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
//         setMessage(noItemsFoundMsg);
//         setTotal(0);
//       } else {
//         setUsers(callapi?.data ?? []);
//         setPagination({
//           ...pagination,
//           totalItemCount: callapi?.totalCount ?? 0,
//         });
//         setTotal(callapi?.totalCount ?? 0);
//       }
//       return callapi?.data;
//     } catch (error: any) {
//       setError("Có lỗi xảy ra khi tải dữ liệu !");
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };
//   const onTableChange = async ({
//     page: { index, size },
//   }: CriteriaWithPagination<TblItemCommand>) => {
//     setPagination({ ...pagination, pageIndex: index, pageSize: size });
//   };
//   const onSearch = async () => {
//     await fetchDataItem(
//       pagination.pageIndex,
//       pagination.pageSize,
//       paramSearch?.keyWord,
//       paramSearch?.inActive
//     );
//   };

//   const handleChooseItem = (item: any) => {
//     onChooseItem(item?.id, item?.itemName);
//     modals.close("item");
//   };

//   const onChange = (selectedOptions: any) => {
//     setSelected(selectedOptions);
//     if (!isNullOrUndefinedArry(selectedOptions)) {
//       const value = selectedOptions[0].value;
//       if (!isNullOrUndefined(value))
//         setParamSearch({ ...paramSearch, inActive: value });
//     } else setParamSearch({ ...paramSearch, inActive: undefined });
//   };

//   const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const key = event?.target?.value;
//     if (!isNullOrUndefined(key))
//       setParamSearch({ ...paramSearch, keyWord: key });
//   };

//   function convertToVnd(amount: number): string {
//     const amountStr: string = amount?.toString();
//     const chunks: string[] = [];

//     for (let i = amountStr?.length - 1; i >= 0; i -= 3) {
//       const chunk = amountStr?.slice(Math.max(i - 2, 0), i + 1);
//       chunks.push(chunk);
//     }

//     const result: string = chunks.reverse().join(".");
//     return result;
//   }

//   useEffect(() => {
//     const fetchData = async () => {
//       await fetchDataItem(
//         pagination.pageIndex,
//         pagination.pageSize,
//         paramSearch?.keyWord,
//         paramSearch?.inActive
//       );
//     };
//     fetchData();
//   }, [pagination.pageIndex, pagination.pageSize]);

//   useEffect(() => {
//     const fetDatabrand = async () => {
//       const data = await getDataBrand();
//       setDataBrand(data?.data.lists);
//     };
//     fetDatabrand();
//   }, []);

//   return (
//     <>
//       <AppSearch
//         loading={loading}
//         onChange={onChange}
//         onChangeText={onChangeText}
//         onSearch={onSearch}
//         elementSearch={elementSearch}
//       />
//       <EuiSpacer size="l" />
//       <EuiBasicTable
//         tableCaption="Demo of EuiDataGrid with selection"
//         items={users ? users : []}
//         itemId="id"
//         error={error}
//         loading={loading}
//         noItemsMessage={isNullOrUndefinedArry(users) ? message : ""}
//         columns={columns}
//         pagination={pagination}
//         isSelectable={true}
//         hasActions={true}
//         responsive={true}
//         onChange={onTableChange}
//         compressed={true}
//       />
//     </>
//   );
// };

// type FormChooseItemProps = {
//   onChooseItem: (idItem: number, productName: string | null) => void;
// };

// export default FormChooseItem;

import {
  Badge,
  Box,
  Button,
  Grid,
  Input,
  Select,
  Text,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconSearch } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import Repository from "../../../../_base/helper/HttpHelper";
import { getDataBrand, getDataBrandV2 } from "../../../../api/ApiSell";
import { _localization } from "../../../../config/location";
import { API_ROUTE } from "../../../../const/apiRoute";
import { Brand } from "../../../../model/ProductList";
import { SelectListItemModel } from "../../../../model/SelectListItem copy";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
  brandId?: number;
}

export interface ItemModel {
  attribute10: null;
  attribute11: string;
  attribute12: string;
  bestSaleStatus: null;
  brandId: null;
  brandIdsStr: null;
  brandName: null;
  categoryId: null;
  categoryIdsStr: null;
  categoryName: null;
  createdBy: null;
  creationDate: string;
  description: null;
  finishedBy: null;
  finishedDate: null;
  hasCategory: null;
  hasCustomerImg: null;
  hasHacomImg: null;
  hasItemImg: null;
  hasPrimaryImg: null;
  hotStatus: null;
  id: number;
  inUse: string;
  itemCode: string;
  itemName: string;
  itemSpec: null;
  itemSummary: null;
  lastUpdateDate: null;
  lastUpdateLogin: null;
  lastUpdatedBy: null;
  longName: null;
  marketPrice: number;
  metaDescription: null;
  metaKeyword: null;
  metaTitle: null;
  newStatus: null;
  onlineStatus: null;
  orderNumber: null;
  primaryImage: null;
  saleOffStatus: null;
  shortName: null;
  sku: string;
  unitSellingPrice: null;
  url: string;
  warrantyDescrition: string;
}

const FormChooseItem = ({ onChooseItem }: FormChooseItemProps) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [dataBrand, setDataBrand] = useState<Brand[]>();
  // Thương hiệu
  const [dataBrandOption, setDataBrandOption] = useState<SelectListItemModel[]>(
    []
  );
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);
  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };
  const calculateDiscountPercent = (
    originalPrice: number,
    dealPrice: number
  ): number => {
    if (!originalPrice || !dealPrice || originalPrice === 0) return 0;
    return Math.round(((originalPrice - dealPrice) / originalPrice) * 100);
  };

  const dataOption = [
    { value: "1", label: "Mới" },
    { value: "2", label: "Hot (Hỏi nhiều)" },
    { value: "3", label: "Bán chạy" },
    { value: "4", label: "Xả hàng (Sale-off)" },
    { value: "5", label: "Chỉ bán online" },
  ];
  const dataOption2 = [
    { value: "1", label: "Giá bán = 0" },
    { value: "2", label: "Còn hàng" },
    { value: "3", label: "Hết hàng" },
    { value: "4", label: "Có giá thị trường" },
  ];
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  const styleTableMantine = {
    fontWeight: "500",
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ row }) => (
          <Badge color="green" variant="dot" radius="sm" size="lg" px="sm">
            <Text fw={500}>{row.original.itemCode}</Text>
          </Badge>
        ),
        size: 135,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 300,
      },
      {
        accessorKey: "primaryImage",
        header: "Ảnh sản phẩm",
        size: 135,
        Cell: ({ row }) => {
          const url = row.original.primaryImage;
          if (!url) return null;
          return (
            <img
              src={url}
              alt="Ảnh Banner lỗi hiển thị"
              style={{ width: "80px", height: "60px", objectFit: "contain" }}
            />
          );
        },
      },
      {
        accessorKey: "brandId",
        header: "Thương hiệu",
        size: 135,
        Cell: ({ row }) => {
          const brand = dataBrand?.find(
            (item: any) => item?.id === row.original.brandId
          );
          return (
            <Text fw={600}>
              {
                dataBrand?.filter(
                  (item: any) => item?.id === row.original.brandId
                )[0]?.name
              }
            </Text>
          );
        },
      },
      {
        accessorKey: "itemCost",
        header: "Giá bán",
        size: 135,
        Cell: ({ row }) => (
          <Text fw={600} c="#FF0000">{`${formatCurrencyVND(
            row.original.itemCost
          )} VND`}</Text>
        ),
      },

      {
        accessorKey: "discountValue",
        header: "Giá thị trường",
        size: 175,
        Cell: ({ row }) => {
          return (
            <Text>
              {`${formatCurrencyVND(row.original.marketPrice ?? 0)} VND`}
              <Text c="red" fw={600}>
                {`(Giảm ${row.original.discountValue}%)`}
              </Text>
            </Text>
          );
        },
      },

      {
        accessorKey: "onhandQuantyty",
        header: "Số lượng tồn kho",
        Cell: ({ row }) => (
          <Text c="#FF0000" fw={600}>
            {row.original.onhandQuantyty ?? 0}
          </Text>
        ),
        // Cell: ({ row }) => {
        //   return (
        //     <Box display={"flex"} style={{ flexDirection: "column" }}>
        //       <Box display={"flex"}>
        //         <Text>Số lượng tổng:</Text>
        //         <Text fw={600} style={{ color: "red", marginLeft: 4 }}>
        //           {row.original.onhandQuantyty}
        //         </Text>
        //       </Box>
        //       <EuiLink>
        //         {row.original.onhandQuantyty == 0 ? (
        //           <Text style={{ color: "red" }}>hết hàng</Text>
        //         ) : (
        //           <Text style={{ color: "blue" }}>còn hàng</Text>
        //         )}
        //       </EuiLink>
        //     </Box>
        //   );
        // },
      },
      {
        accessorKey: "warrantyDescrition",
        header: "Bảo hành",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "action",
        header: "Thêm sản phẩm",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Thêm sản phẩm">
              <Button
                color="blue"
                variant="outline"
                ml={20}
                onClick={() => handleChooseItem(row.original)}
              >
                Chọn
              </Button>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataBrand]
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.brandId) {
        queryParams.append("brandId", String(search.brandId));
      }
      if (search && search.status) {
        queryParams.append("StatusFilter", search.status);
      }
      if (search && search.location) {
        queryParams.append("SearchType", search.location);
      }
      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${API_ROUTE.GET_LIST_PRODUCT}?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  //   Lấy data thương hiệu sản phẩm
  const fetchDataBrand = async (keySearch?: string) => {
    try {
      let url = "?Skip=0&Take=1000";
      if (keySearch) {
        url += `&KeySearch=${keySearch}`;
      }
      const response = await getDataBrandV2(url);
      if (response && response.data.lists) {
        const formattedData = response.data.lists
          .filter((i: any) => i.id && i.name)
          .map((item: any, index: number) => ({
            value: item.id.toString(),
            label: item.name,
          }));
        setDataBrand(response.data.lists);
        setDataBrandOption(formattedData);
      }
    } catch (error) {
      console.log("error fetchDataBrand", error);
    }
  };

  // const handleChooseItem = (item: any) => {
  //   onChooseItem(
  //     item?.id,
  //     item?.primaryImage,
  //     item?.itemCode,
  //     item?.sku,
  //     item?.itemName,
  //     item?.unitSellingPrice,
  //     item?.marketPrice
  //   );
  //   modals.close("item");
  // };
  const handleChooseItem = (item: ItemModel) => {
    onChooseItem(
      item?.id,
      item?.itemName,
      item?.itemCode,
      item?.sku,
      item?.primaryImage,
      item?.unitSellingPrice,
      item?.marketPrice,
      item?.url
    );
    modals.close("item");
  };

  console.log(data, "sdsasaddsadsa");

  const table = useMantineReactTable({
    columns,
    data: data || [], // Use data state instead of users
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualPagination: true,
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    enableRowSelection: false,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["active", "priority", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    const fetDatabrand = async () => {
      const data = await getDataBrand();
      setDataBrand(data?.data.lists);
    };
    fetDatabrand();
  }, []);
  console.log(
    "data brand",
    dataBrand?.filter((item: any) => item?.id === 1)[0]?.name
  );
  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus, editViewProduct]);
  return (
    <Box>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Select
                placeholder="Đặc điểm sản phẩm"
                data={dataOption}
                clearable
                key={form.key("status")}
                {...form.getInputProps("status")}
              />
              <Select
                placeholder="Lọc theo điều kiện"
                data={dataOption2}
                clearable
                key={form.key("location")}
                {...form.getInputProps("location")}
              />
              <Select
                placeholder="Chọn thương hiệu"
                data={dataBrandOption}
                clearable
                onClick={() => {
                  if (dataBrandOption.length === 0) {
                    fetchDataBrand();
                  }
                }}
                searchable
                key={form.key("brandId")}
                {...form.getInputProps("brandId")}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

// type FormChooseItemProps = {
//   onChooseItem: (
//     idItem: number,
//     imgUrl: string | null,
//     itemCode: string | null,
//     sku: string | null,
//     productName: string | null,
//     unitSellingPrice: number | null,
//     marketPrice: number | null
//   ) => void;
// };
type FormChooseItemProps = {
  onChooseItem: (
    idItem: number,
    productName: string | null,
    itemCode?: string | null,
    sku?: string | null,
    primaryImage?: string | null,
    unitSellingPrice?: number | null,
    marketPrice?: number | null,
    url?: string | null
  ) => void;
};

export default FormChooseItem;
